import { useId, type ReactNode } from "react";
import { MERGED_SERIES_KEY } from "./evalCompareModel";

const MERGED_RAINBOW_COLORS = [
  "#ef4444",
  "#f59e0b",
  "#eab308",
  "#22c55e",
  "#06b6d4",
  "#3b82f6",
  "#a855f7",
] as const;

export const MERGED_RAINBOW_BACKGROUND = `linear-gradient(135deg, ${MERGED_RAINBOW_COLORS.join(", ")})`;

export function useMergedSeriesGradientId(): string {
  const id = useId().replace(/:/g, "");
  return `merged-rainbow-${id}`;
}

export function mergedSeriesPaint(key: string, color: string, gradientId: string): string {
  return key === MERGED_SERIES_KEY ? `url(#${gradientId})` : color;
}

export function MergedSeriesGradient({ id }: { id: string }): ReactNode {
  return (
    <linearGradient id={id} x1="0%" y1="100%" x2="100%" y2="0%">
      {MERGED_RAINBOW_COLORS.map((color, index) => (
        <stop
          key={color}
          offset={`${(index / (MERGED_RAINBOW_COLORS.length - 1)) * 100}%`}
          stopColor={color}
        />
      ))}
    </linearGradient>
  );
}
